import { atomWithStorage } from 'jotai/utils';

export type ScreenerFacilityChangeSource =
  | 'manual'
  | 'auto_from_all_leads'
  | 'unknown';

export const screenerFacilityChangeSourceAtom =
  atomWithStorage<ScreenerFacilityChangeSource>(
    'screenerFacilityChangeSource',
    'unknown'
  );
